import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.prescriptiondetail, { type, payload }) {
    switch (type) {
        case types.PRESCRIPTIONDETAIL_REQUEST:
            return {
                ...initialState.prescriptiondetail,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.PRESCRIPTIONDETAIL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.PRESCRIPTIONDETAIL_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}